import React, { useEffect } from "react";
import PageLayout from "../ui/PageLayout";
import PageHero from "../ui/PageHero";
import "./Donate.css";

const Donate = () => {
  useEffect(() => {
    // 1. Safely inject the Danamojo script ONLY ONCE
    const scriptId = "danamojo-widget-script";

    if (!document.getElementById(scriptId)) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.src = "https://danamojo.org/dm/js/widget.js";
      script.type = "text/javascript";
      script.async = true;
      document.body.appendChild(script);
    }

    // 2. Fallback timer if the system is down
    const timer = setTimeout(() => {
      const container = document.getElementById("ngoContentContainer");
      if (container && container.innerHTML.length < 40) {
        container.innerHTML =
          "<center><p style='color:#a94442;'>We are sorry that our systems are down. We will be up shortly. Apologies for the inconvenience.</p></center>";
      }
    }, 5000);

    // 3. Cleanup function (Optional but good practice)
    return () => {
      clearTimeout(timer);
      // Leaving it in the document prevents it from re-downloading 
      // and re-declaring 'nav' if the user leaves and returns to this page.
    };
  }, []);

  return (
    <PageLayout>
      <PageHero
        title="Donate"
        eyebrow="Make a Difference"
        subtitle="Your kindness fuels our mission. Every contribution big or small creates ripples of change across India."
        light
      />

      <section className="py-12 bg-white">
        <div className="ku-container max-w-4xl mx-auto">

          <div id="dmScriptContainer" style={{ display: "none" }}>
            <a href="#">Donate Now</a>
          </div>

          <div
            id="ngoContentContainer"
            iNGOId="932"
            oLayout="GRID"
            oDisplay="product"
            oDisplayTab="once,monthly"
            className="donate-page"
          >
            <center>
              <img
                alt="please wait..."
                src="https://danamojo.org/dm/css/images/loading.gif"
              />
            </center>
          </div>

        </div>
      </section>
    </PageLayout>
  );
};

export default Donate;